import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'MENUITEMS.HOME.DASHBOARD',
    moduleName: 'dashboard',
    icon: 'fas fa-home',
    class: 'menu-toggle',
    groupTitle: false,
    submenu: [
      {
        path: 'dashboard/main',
        title: 'Plazza',
        moduleName: 'dashboard',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        submenu: []
      },
    ]
  },

  {
    path: '',
    title: 'MENUITEMS.MAIN.MODULES',
    moduleName: '',
    icon: '',
    class: '',
    groupTitle: true,
    submenu: []
  },
  {
    path: '',
    title: 'MENUITEMS.MAIN.MASTER',
    moduleName: 'master',
    icon: 'fas fa-tools',
    class: 'menu-toggle',
    groupTitle: false,
    submenu: [
      {
        path: 'master/warehouse',
        title: 'MENUITEMS.MAIN.WAREHOUSE',
        moduleName: 'master',
        icon: '',
        class: 'ml-sub-sub-menu',
        groupTitle: false,
        submenu: []
      },
      {
        path: 'master/item',
        title: 'MENUITEMS.MAIN.ITEM',
        moduleName: 'master',
        icon: '',
        class: 'ml-sub-sub-menu',
        groupTitle: false,
        submenu: []
      }
    ]
  },
  {
    path: '/',
    title: 'MENUITEMS.MAIN.PROCESS',
    moduleName: 'process',
    icon: 'fas fa-list',
    class: 'menu-toggle',
    groupTitle: false,
    submenu: [
      {
        path: 'process/order',
        title: 'MENUITEMS.MAIN.ORDER',
        moduleName: 'location',
        icon: '',
        class: 'ml-sub-sub-menu',
        groupTitle: false,
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'MENUITEMS.MAIN.REPORTS',
    moduleName: 'reports',
    //permission: [''],
    icon: 'fas fa-file',
    class: 'menu-toggle',
    groupTitle: false,
    submenu: [
      {
        path: 'reports/commission',
        title: 'MENUITEMS.MAIN.COMMISSION',
        moduleName: 'reports',
        //permission: [''],
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        submenu: []
      },
    ]
  },
  {
    path: '',
    title: 'MENUITEMS.MAIN.ADDONS',
    moduleName: '',
    icon: '',
    class: '',
    groupTitle: true,
    submenu: []
  },
  {
    path: 'addons/question',
    title: 'MENUITEMS.MAIN.QUESTIONS',
    moduleName: 'setting',
    icon: 'fas fa-question',
    class: '',
    groupTitle: false,
    submenu: []
  },
  {
    path: 'addons/promotion',
    title: 'MENUITEMS.MAIN.PROMOTIONS',
    moduleName: 'setting',
    icon: 'fas fa-tag',
    class: '',
    groupTitle: false,
    submenu: []
  },
  {
    path: '',
    title: 'MENUITEMS.MAIN.SETTING',
    moduleName: '',
    icon: '',
    class: '',
    groupTitle: true,
    submenu: []
  },
  {
    path: 'setting/company',
    title: 'MENUITEMS.MAIN.COMPANY',
    moduleName: 'setting',
    icon: 'fas fa-building',
    class: '',
    groupTitle: false,
    submenu: []
  },
  {
    path: 'setting/contract',
    title: 'MENUITEMS.MAIN.CONTRACT',
    moduleName: 'setting',
    icon: 'fas fa-file-contract',
    class: '',
    groupTitle: false,
    submenu: []
  },
  {
    path: '',
    title: 'MENUITEMS.MAIN.ACCESS',
    moduleName: '',
    icon: '',
    class: '',
    groupTitle: true,
    submenu: []
  },
  {
    path: '/',
    title: 'MENUITEMS.MAIN.USERS',
    moduleName: 'access',
    icon: 'fas fa-users',
    class: 'menu-toggle',
    groupTitle: false,
    submenu: [
      {
        path: 'access/user',
        title: 'MENUITEMS.MAIN.USERS',
        moduleName: 'access',
        icon: '',
        class: 'ml-sub-sub-menu',
        groupTitle: false,
        submenu: []
      },
    ]
  },
];
